import { ApiClientConfig, Client } from '@/api-clients/dashboard-api';
import { useAppConfigStore } from '@/stores/appConfigStore';
import { sendSentryEvent } from '@/helpers/sentryHelpers';

export async function callDashboardApi<TResult>(
  method: (apiClient: Client) => Promise<TResult>
): Promise<TResult> {
  const apiClient = createDashboardClient();

  try {
    return await method(apiClient);
  }
  catch (err) {
    sendSentryEvent(err);
    throw err;
  }
}

function createDashboardClient(
  customizeConfig?: (callingConfig: ApiClientConfig) => void
): Client {
  const appConfigStore = useAppConfigStore();
  const apiBaseUrl = appConfigStore.appConfig.dashboardApiUrl;
  const callingConfig: ApiClientConfig = {
    defaultHeaders: {},
  };
  if (customizeConfig) {
    customizeConfig(callingConfig);
  }
  const apiClient = new Client(callingConfig, apiBaseUrl);
  return apiClient;
}
